import Vue from "vue";
import { validatePartRequest, submitOrderRequest } from "../requests";

export const RequestStatus = Object.freeze({
  Pending: "REQUEST_PENDING",
  Failed: "REQUEST_FAILED",
  Success: "REQUEST_SUCCESS",
  Invalid: "REQUEST_INVALID"
});

export default {
  namespaced: true,
  state: {
    order: {
      items: {},
      pickup: false,
      note: "",
      number: -1
    },
    submit: {
      requested: false,
      status: RequestStatus.Failed
    }
  },
  mutations: {
    resetState(state) {
      state.order = {
        items: {},
        pickup: false,
        note: "",
        number: -1
      };
      state.submit = {
        requested: false,
        status: RequestStatus.Failed
      };
    },
    addItem(state, { partNumber, orderQuantity }) {
      if (state.order.items[partNumber]) {
        state.order.items[partNumber].orderQuantity =
          Number(orderQuantity) + Number(state.order.items[partNumber].orderQuantity);
      } else {
        state.order.items = Object.assign({}, state.order.items, {
          [partNumber]: {
            part_number: partNumber,
            orderQuantity: Number(orderQuantity),
            stock: 0,
            status: RequestStatus.Pending,
            error: false,
            description: "",
            availabile: false,
            vendor: "",
            bin: "",
            class: "",
            dealer_price: -1,
            retail_price: -1
          }
        });
      }
    },
    updateItemDetails(state, { partNumber, status, error, part }) {
      state.order.items = Object.assign({}, state.order.items, {
        [partNumber]: { ...state.order.items[partNumber], status, error, ...part }
      });
    },
    updateSubmitStatus(state, status) {
      state.submit.requested = true;
      state.submit.status = status;
    },
    updateItemQuantity(state, { partNumber, orderQuantity }) {
      state.order.items[partNumber].orderQuantity = orderQuantity;
    },
    removeItem(state, { partNumber }) {
      Vue.delete(state.order.items, partNumber);
    },
    updatePickup(state, val) {
      state.order.pickup = val;
    },
    updateNote(state, val) {
      state.order.note = val;
    },
    updateOrderNumber(state, val) {
      state.order.number = val;
    }
  },
  actions: {
    addItem(store, { partNumber, orderQuantity }) {
      store.commit("addItem", { partNumber, orderQuantity });
      //validate parts
      validatePartRequest(store.rootState.app.token, store.state.order.items[partNumber].part_number)
        .then(res => {
          //handle invalid part but valid request
          if (res.data.error) {
            return store.commit("updateItemDetails", {
              partNumber,
              status: RequestStatus.Invalid,
              error: true
            });
          }

          //commit to store
          return store.commit("updateItemDetails", {
            partNumber,
            status: RequestStatus.Success,
            error: false,
            part: { ...res.data }
          });
        })
        .catch(() => {
          return store.commit("updateItemDetails", {
            partNumber,
            status: RequestStatus.Failed,
            error: true
          });
        });
    },
    submitOrder(store) {
      store.commit("updateSubmitStatus", RequestStatus.Pending);
      var itemsObject = store.state.order.items;
      var itemIds = Object.keys(itemsObject);
      // validate parts
      // no parts
      if (itemIds.length == 0) {
        return Promise.reject("no items in order");
      }
      // error
      else if (itemIds.find(id => itemsObject[id].error == true) != null) {
        return Promise.reject("order contains invalid parts");
      }
      // request pending or failed
      else if (
        itemIds.find(
          id => itemsObject[id].status == RequestStatus.Pending || (itemsObject[id].status == RequestStatus.Failed) != null
        )
      )
        return submitOrderRequest(
          store.rootState.app.token,
          Object.keys(store.state.order.items).map(key => store.state.order.items[key]), //flatten
          store.state.order.pickup,
          store.state.order.note
        )
          .then(res => {
            store.commit("updateSubmitStatus", RequestStatus.Success);
            store.commit("updateOrderNumber", res.data.order_number);
          })
          .catch(() => {
            store.commit("updateSubmitStatus", RequestStatus.Failed);
          });
    }
  },
  getters: {
    itemDetails: state => partNumber => {
      return state.order.items[partNumber];
    },
    items: state => {
      return state.order.items;
    }
  }
};
